
import { useEffect } from "react"
import { useLocation } from "react-router-dom"
import {posthog} from "@/lib/posthog.ts";

export default function PageviewTracker() {
    const { pathname, search } = useLocation()
    useEffect(() => { posthog.capture("$pageview") }, [pathname, search])
    return null
}
